import { add, listen, qsa, toggle } from "@fluorescent/dom";

import { section } from "@/glow";
import { on, emit } from "@/glow/events";

const slideshowOpts = {
  adaptiveHeight: false,
  draggable: false,
  fade: true,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true,
  pauseAutoPlayOnHover: !window.Shopify.designMode,
};

const classes = {
  active: "is-active",
};
section("announcement-bar", {
  timer: null,
  listeners: [],

  onLoad() {
    const timing = parseInt(this.container.dataset.timing);
    const announcements = qsa("[data-announcement]", this.container);

    if (!announcements.length) return;

    document.documentElement.style.setProperty(
      "--announcement-height",
      this.container.offsetHeight + "px"
    );

    if (announcements.length > 1) {
      import(flu.chunks.flickity).then(({ Flickity }) => {
        this.slideshow = new Flickity(this.container, {
          ...slideshowOpts,
          autoPlay: timing,
          on: {
            // Need to add a modifier to animate after the first slide has changed
            change(index) {
              announcements.forEach((el, i) =>
                toggle(el, classes.active, index === i)
              );
            },
          },
        });

        this.slideshow.on("pointerUp", () => this.handleRestart());
        emit("announcement-bar:initialized");
      });

      this.listeners.push(
        listen(this.container, "touchend", () => this.handleRestart())
      );
    } else {
      add(announcements[0], "is-active", "is-selected");
    }
  },

  handleRestart() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.slideshow.playPlayer(), 3500);
  },

  handleBlockSelect(slideIndex) {
    this.slideshow.pausePlayer();
    this.slideshow.select(slideIndex);
  },

  onBlockSelect({ target }) {
    if (this.slideshow) {
      this.handleBlockSelect(target.dataset.index);
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("announcement-bar:initialized", () => {
          this.handleBlockSelect(target.dataset.index);
        })
      );
    }
  },

  onBlockDeselect() {
    if (this.slideshow) {
      this.slideshow.unpausePlayer();
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("announcement-bar:initialized", () => {
          this.slideshow.unpausePlayer();
        })
      );
    }
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.listeners.forEach(l => l());
  },
});
